import { useMutation, useQueryClient } from 'react-query';

import { getClient } from '@/lib/restClient';
import { BrandSalesStateGroupRulesService } from '@/services/BrandSalesStateGroupRules';

interface UpsertParams {
  brandId: number;
  rulesText: string;
}

export const useUpsertBrandSalesStateGroupRules = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isLoading, error, isSuccess } = useMutation<
    void,
    Error,
    UpsertParams
  >(
    async (params: UpsertParams): Promise<void> => {
      const service = new BrandSalesStateGroupRulesService(getClient());
      return await service.upsert(params.brandId, {
        rules_text: params.rulesText,
      });
    },
    {
      onSuccess: (_data, variables) => {
        queryClient.invalidateQueries([
          'brandSalesStateGroupRules',
          variables.brandId,
        ]);
      },
      onError: (error) => {
        alert(error.message);
      },
    }
  );

  return {
    upsertRules: mutateAsync,
    isLoading,
    error,
    isSuccess,
  };
};
